<template>
  <div class="dhs-hero-card-container">
    <img
      :src="require(`@/assets/fc-white.svg`)"
      width="28"
      height="24"
      alt="First Canadian Logo"
      class="position-absolute"
    />
    <div class="spotlight-dhs-container d-flex">
      <h4 class="text-white my-0 dhs-text duration-text">
        {{ spotlight.payload.message[11] }}
        <font-awesome-icon
          v-if="isFullWidth"
          class="icon ml-2"
          :icon="['far', 'chevron-right']"
          :style="{ color: '#ffffff', fontSize: '17px' }"
        />
      </h4>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'FirstCanadianBreakdown',
  props: {
    spotlight: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters('spotlight', ['totalSpotlightCardCount']),
    isFullWidth() {
      return this.totalSpotlightCardCount <= 1;
    },
  },
};
</script>

<style scoped lang="scss">
.dhs-hero-card-container {
  font-size: 14px;
  .spotlight-dhs-container {
    z-index: 10;
    position: relative;
    height: 100%;
    align-items: flex-end;
    .duration-text {
      font-size: 18px;
      font-weight: bold;
      line-height: 22.5px;

      @media (min-width: 575px) {
        font-size: 20px;
        line-height: 25px;
      }
    }
  }
}
</style>
